import { NgModule } from '@angular/core';
import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { TamasAlunoService } from '../tamas-aluno.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AlertaSimplesDialog } from '../alerta-simples';
import { AlertaInputDialog } from '../alerta-input';
import { AlertaConfirmDialog } from '../alerta-confirm';
import { Location } from '@angular/common';
import { AlertaTermosDialog } from '../alerta-termos';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';


@Component({
  selector: 'app-dashboard-treino',
  templateUrl: './dashboard-treino.component.html',
  styleUrls: ['./dashboard-treino.component.css']
})
export class DashboardTreinoComponent implements OnInit {
  @ViewChild("treinohead") exc1p: ElementRef;
  hideLoginLoad: boolean = false;
  meusDados: any = '';
  dadosRecuperar: any = '';
  tentativasFail: any = 0;
  isPassword: boolean = true;
  idCliente: any = 0;
  fcmToken: any = '';
  idPaciente: any = '';
  arrExercicios: any[] = [];
  idPlano: any = 0;
  idTreino: any = 0;
  titexc: any = '';
  qtdseries: any = '';
  qtdrep: any = '';
  tempodescanso: any = '';
  obsexc: any = '';
  linkyoutube: any = '';
  editando: boolean = false;
  idEditando: any = 0;
  NomeTreino: any = '';
  listaExc: any[] = [];
  filteredOptions: Observable<string[]>;
  myControl = new FormControl();
  cooldown: any = 0;
  tEnviado: boolean = false;
  constructor(private route: ActivatedRoute, public tmaService: TamasAlunoService, public router: Router, public dialog: MatDialog, private _location: Location) { }

  ngOnInit() {
    this.tmaService.eventoFS(true);
    this.idPaciente = this.route.snapshot.paramMap.get('idpaciente');
    this.idPlano = this.route.snapshot.paramMap.get('idplano');
    this.idTreino = this.route.snapshot.paramMap.get('idtreino');
    //this.NomeTreino = 'Treino A - Dorsal';
    //fake
    //this.arrExercicios.push({Id: 1, Descritivo: 'Remada Frontal puxador aberto', Observacoes: 'Até a falha', NumSeries: 3, NumRepeticoes: 8, TempoDescanso: 45});


    //   this.tmaService.getJsonExc("").subscribe((qRes) =>{
    //   console.log(qRes);
    //   this.listaExc = qRes['exerciciosgym'];
    //   this.filteredOptions = this.myControl.valueChanges
    //   .pipe(
    //     startWith(''),
    //     map(value => this._filter(value))
    //   );
    // })


    this.carregarListaExc();


    // this.arrTreinos.push({Id: 1, NomeTreino: 'Treino A - Dorsal'});
    // this.arrTreinos.push({Id: 2, NomeTreino: 'Treino B - Bíceps e Tríceps'});
    // this.arrTreinos.push({Id: 3, NomeTreino: 'Treino C - Aeróbicos HIT'});
  }
  ngOnDestroy() {
    console.log("destroy");
    //this.tmaService.eventoFS(false);
  }


  carregarListaExc(): void {
    this.hideLoginLoad = false;
    var dadosIn = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idpaciente=' + this.idPaciente + '&idficha=' + this.idPlano + '&idtreino=' + this.idTreino;
    this.tmaService.getListaExerciciosT(dadosIn)
      .subscribe((qRes) => {
        this.hideLoginLoad = true;
        console.log(qRes);
        if (qRes['res'] == 'ok') {
          this.arrExercicios = qRes['objExercicios'];
          this.NomeTreino = qRes['nometreino'];
          this.tEnviado = qRes['already'];
          this.cooldown = qRes['cooldown'];
        }
        else {
          //algo errado
          const avisoIC = this.dialog.open(AlertaConfirmDialog, {
            // width: '250px',
            disableClose: true,
            data: { tituloAlerta: "Aviso", textoAlerta: "Ocorreu um erro ao carregar as informações desta ficha. Tente novamente", textoCancel: "", textoConfirm: "OK" }
          });
          avisoIC.afterClosed().subscribe((result) => {
            this.voltar();
          });
          // const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          //   disableClose:true,
          //   data: {textoAlerta: "Não foi possível carregar os exercícios deste treino. Tente novamente", iconAlerta: 'warning'}
          // });
        }
      },
        (error) => {
          this.hideLoginLoad = true;
          const avisoIC = this.dialog.open(AlertaConfirmDialog, {
            // width: '250px',
            disableClose: true,
            data: { tituloAlerta: "Aviso", textoAlerta: "Verifique sua conexão com a internet. Tente novamente", textoCancel: "", textoConfirm: "OK" }
          });
          avisoIC.afterClosed().subscribe((result) => {
            this.voltar();
          });

          // const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          //   disableClose:true,
          //   data: {textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning'}
          // });
        })
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.listaExc.filter(option => option.exc.toLowerCase().includes(filterValue));
  }

  addTreino(): void {
    const addNT = this.dialog.open(AlertaConfirmDialog, {
      //width: '250px',
      disableClose: true,
      data: { iconAlerta: "", tituloAlerta: "Novo Treino", textoAlerta: '', textoCancel: 'Cancelar', textoConfirm: "OK", nTreino: true }
    });
    addNT.afterClosed().subscribe(result => {
      console.log(result);
      if (result !== false && result !== '') {
        //this.arrTreinos.push({Id: 4, NomeTreino: result});


      }
    })
  }

  excluirT(): void {

    if (this.cooldown > 3 && this.tEnviado) {
      const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: { textoAlerta: "Este plano já foi enviado há mais de 3 dias e não é possível excluir os exercícios!", iconAlerta: 'warning' }
      });
    }
    else{
      const excluirTreino = this.dialog.open(AlertaConfirmDialog, {
        //width: '250px',
        disableClose: true,
        data: { iconAlerta: "delete_forever", tituloAlerta: "Excluir", textoAlerta: "Confirma a exclusão deste treino?", textoCancel: 'Não', textoConfirm: "SIM" }
      });
  
      excluirTreino.afterClosed().subscribe(result => {
        console.log(result);
        if (result) {
          let customParams = {
            //lista: localStorage.getItem('turboCart'),
            email: this.tmaService.hcEmail,
            senha: this.tmaService.hcSenha,
            idpaciente: this.idPaciente,
            idficha: this.idPlano,
            idtreino: this.idTreino
          };
          this.hideLoginLoad = false;
          this.tmaService.excluirFichaTreino(customParams).subscribe((qRes) => {
            this.hideLoginLoad = true;
            console.log(qRes);
            if (qRes['res'] == 'ok') {
              this.router.navigate(['/dashboard/add-treino/' + this.idPaciente + '/' + this.idPlano]);
            }
            else {
              const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: { textoAlerta: "Ocorreu um erro ao excluir esta ficha de treino. Tente novamente", iconAlerta: 'warning' }
              });
            }
          },
            (error) => {
              this.hideLoginLoad = true;
              const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
              });
            })
  
        }
      })
    }
    
    
  }

  removerExc(idExc: any): void {
    if (this.cooldown > 3 && this.tEnviado) {
      const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: { textoAlerta: "Este plano já foi enviado há mais de 3 dias e não é possível excluir os exercícios!", iconAlerta: 'warning' }
      });
    }
    else{
      const remExc = this.dialog.open(AlertaConfirmDialog, {
        //width: '250px',
        disableClose: true,
        data: { iconAlerta: "delete_outline", tituloAlerta: "Excluir", textoAlerta: "Confirma a exclusão deste exercício?", textoCancel: 'Cancelar', textoConfirm: "SIM" }
      });
  
      remExc.afterClosed().subscribe(result => {
        console.log(result);
        if (result) {
          let customParams = {
            //lista: localStorage.getItem('turboCart'),
            email: this.tmaService.hcEmail,
            senha: this.tmaService.hcSenha,
            idpaciente: this.idPaciente,
            idficha: this.idPlano,
            idtreino: this.idTreino,
            idexercicio: idExc
          };
          this.hideLoginLoad = false;
          this.tmaService.excluirExercicioT(customParams).subscribe((qRes) => {
            this.hideLoginLoad = true;
            console.log(qRes);
            if (qRes['res'] == 'ok') {
              this.carregarListaExc();
            }
            else {
              const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: { textoAlerta: "Ocorreu um erro ao excluir este exercício. Tente novamente", iconAlerta: 'warning' }
              });
            }
          },
            (error) => {
              this.hideLoginLoad = true;
              const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
              });
            })
  
          // var qIndex = this.arrExercicios.findIndex(x => x.Id == idExc);
          // this.arrExercicios.splice(qIndex, 1);
        }
      })
    }
    
  }

  editExc(idExc: any): void {
    //inserir os parâmetros no input
    //this.titexc = "Remada Baixa com puxador fechado";

    var eIndex = this.arrExercicios.findIndex(x => x.Id == idExc);
    console.log(idExc);
    console.log(eIndex);
    this.titexc = this.arrExercicios[eIndex].Descritivo;
    this.obsexc = this.arrExercicios[eIndex].Observacoes;
    this.linkyoutube = this.arrExercicios[eIndex].LinkYoutube;
    this.qtdrep = this.arrExercicios[eIndex].NumRepeticoes;
    this.qtdseries = this.arrExercicios[eIndex].NumSeries;
    this.tempodescanso = this.arrExercicios[eIndex].TempoDescanso;

    this.editando = true;
    this.idEditando = idExc;
    this.exc1p.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  incluirExc(): void {
    //this.arrExercicios.push({Id: 1, Descritivo: 'Remada Frontal puxador aberto', Observacoes: 'Até a falha', NumSeries: 3, NumRepeticoes: 8, TempoDescanso: 45});
    //server side

    if (this.cooldown > 3 && this.tEnviado) {
      const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: { textoAlerta: "Este plano já foi enviado há mais de 3 dias e não é possível adicionar mais exercícios!", iconAlerta: 'warning' }
      });
    }
    else {
      if (this.editando) {
        //atualizar 

        var dadosExerc = {};
        dadosExerc = {
          Descritivo: this.titexc,
          NumSeries: this.qtdseries,
          NumRepeticoes: this.qtdrep,
          TempoDescanso: this.tempodescanso,
          Observacoes: this.obsexc,
          LinkYoutube: this.linkyoutube
        };
        var qExc = JSON.stringify(dadosExerc);
        let customParams = {
          //lista: localStorage.getItem('turboCart'),
          email: this.tmaService.hcEmail,
          senha: this.tmaService.hcSenha,
          idpaciente: this.idPaciente,
          idficha: this.idPlano,
          idtreino: this.idTreino,
          idexercicio: this.idEditando,
          dadosExc: qExc,
        };
        this.hideLoginLoad = false;
        this.tmaService.atualizarExcT(customParams).subscribe((qRes) => {
          this.hideLoginLoad = true;
          console.log(qRes);
          if (qRes['res'] == 'ok') {
            this.titexc = '';
            this.obsexc = '';
            this.qtdrep = '';
            this.qtdseries = '';
            this.tempodescanso = '';
            this.linkyoutube = '';
            this.editando = false;
            this.carregarListaExc();
          }
          else {
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: { textoAlerta: "Ocorreu um erro ao criar este plano. Tente novamente", iconAlerta: 'warning' }
            });
          }
        },
          (error) => {
            this.hideLoginLoad = true;
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
            });
          })
      }
      else {
        //new
        var dadosExerc = {};
        dadosExerc = {
          Descritivo: this.titexc,
          NumSeries: this.qtdseries,
          NumRepeticoes: this.qtdrep,
          TempoDescanso: this.tempodescanso,
          Observacoes: this.obsexc,
          LinkYoutube: this.linkyoutube
        };
        var qExc = JSON.stringify(dadosExerc);
        let customParams = {
          //lista: localStorage.getItem('turboCart'),
          email: this.tmaService.hcEmail,
          senha: this.tmaService.hcSenha,
          idpaciente: this.idPaciente,
          idficha: this.idPlano,
          idtreino: this.idTreino,
          dadosExc: qExc,
        };
        this.hideLoginLoad = false;
        this.tmaService.addNovoExcT(customParams).subscribe((qRes) => {
          this.hideLoginLoad = true;
          console.log(qRes);
          if (qRes['res'] == 'ok') {
            this.titexc = '';
            this.obsexc = '';
            this.qtdrep = '';
            this.qtdseries = '';
            this.tempodescanso = '';
            this.carregarListaExc();
          }
          else {
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: { textoAlerta: "Ocorreu um erro ao criar este plano. Tente novamente", iconAlerta: 'warning' }
            });
          }
        },
          (error) => {
            this.hideLoginLoad = true;
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
            });
          })
      }


      // var fakeId = 0;
      // fakeId = this.arrExercicios.length + 1;
      // this.arrExercicios.push({Id: fakeId, Descritivo: this.titexc, Observacoes: this.obsexc, NumSeries: this.qtdseries, NumRepeticoes: this.qtdrep, TempoDescanso: this.tempodescanso });
    }

  }
  cancelarEdit(): void {
    this.editando = false;
    this.titexc = '';
    this.obsexc = '';
    this.qtdrep = '';
    this.qtdseries = '';
    this.tempodescanso = '';
    this.linkyoutube = '';
  }
  duplicarExc(): void {
    //same as incluir, w/o clear fields
    this.editando = false;
    var fakeId = 0;
    fakeId = this.arrExercicios.length + 1;
    this.arrExercicios.push({ Id: fakeId, Descritivo: this.titexc, Observacoes: this.obsexc, NumSeries: this.qtdseries, NumRepeticoes: this.qtdrep, TempoDescanso: this.tempodescanso });
  }
  clearInp(): void {
    this.titexc = '';
    this.obsexc = '';
    this.qtdrep = '';
    this.qtdseries = '';
    this.tempodescanso = '';
    this.linkyoutube = '';
    this.editando = false;
  }
  goTreino(idTreino: any): void {
    //this.router.navigate(['/dashboard/treino/' + this.nickPaciente + '/' + this.idPlano + '/' + idTreino]);
  }
  voltar(): void {
    //this._location.back();
    this.router.navigate(['/dashboard/add-treino/' + this.idPaciente + '/' + this.idPlano]);

  }

}